import * as Sentry from '@sentry/react';
import { useCallback, useEffect } from 'react';
import { ErrorComponentProps } from '@tanstack/react-router';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useClearCache from '@/hooks/useClearCache.ts';

export default function RouteError({ error }: ErrorComponentProps) {
  const { t } = useTranslation(['manager']);
  const [clearCache] = useClearCache();

  const handleOnClick = useCallback(async () => {
    await clearCache();
    window.location.replace('/');
  }, [clearCache]);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Stack
      flex={1}
      spacing={3}
      p={3}
      alignItems="center"
      justifyContent="center"
      textAlign="center">
      <Typography variant="h2">{t('errorBoundary.header')}</Typography>
      <Typography variant="h4">{t('errorBoundary.description')}</Typography>
      <Button variant="text" onClick={handleOnClick}>
        {t('errorBoundary.actionButton.restart')}
      </Button>
    </Stack>
  );
}
